import React from 'react'
import AbstractAdminVer from '../utils/AbstractAdminVer'

function VerProductosAgricolas() {
  return (
    <div className="section h-full mx-2 my-5 md:w-10/12">
      <AbstractAdminVer
        objectName={{
          plural: "Productos Agrícolas",
          singular: "producto_agricola",
          formal: "productos-agricolas",
          informal:"producto agrícola"
        }}
        itemName={"nombre"}
        query={"productosempresa"}
        configPath={"utils/configFiles/config.json"}
      ></AbstractAdminVer>{" "}
    </div>
  )
}

export default VerProductosAgricolas